module.exports = __webpack_public_path__ + "static/media/cash_game.64d71fc1.png";